import { GetStaticProps } from 'next'
import React from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'
import { ListedAttributeUkiyoes } from '@/components/ListedAttributeUkiyoes'
// eslint-disable-next-line sort-imports
import { getMasterData, MasterData } from '@/lib/UkiyoeData'

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const attribute = params?.attribute ? (params.attribute as string) : null
  if (!attribute) {
    return {
      notFound: true,
    }
  }
  const value = params?.value ? (params.value as string) : null
  if (!value) {
    return {
      notFound: true,
    }
  }

  const data = getMasterData()
  try {
    const attributeInfo = data[attribute][value]
    return {
      props: {
        attribute,
        value,
        attributeInfo,
      },
    }
  } catch (e) {
    console.error(e)
    return {
      notFound: true,
    }
  }
}

export async function getStaticPaths() {
  const data = getMasterData()
  const paths: string[] = []
  Object.keys(data).forEach((attributeName) => {
    Object.keys(data[attributeName]).forEach((value) => {
      paths.push(`/attributes/${attributeName}/${value}`)
    })
  })

  return {
    paths,
    fallback: false,
  }
}

type Props = {
  attribute: string
  value: string
  attributeInfo: MasterData['key']['key']
}

const Attribute = ({ attribute, value, attributeInfo }: Props) => {
  return (
    <Layout>
      <Head
        path={`/attributes/${attribute}/${value}`}
        title={`${attribute.toUpperCase()}: ${value}`}
      />
      <Container>
        <Header />
        <ListedAttributeUkiyoes attribute={attribute} value={value} attributeInfo={attributeInfo} />
      </Container>
    </Layout>
  )
}

export default Attribute
